var TOKENS = {
  borderColor: "borderColor",
  iconColor: "iconColor"
};
export default TOKENS;